export const PAYMENT_STATUS_ERROR = 'error';
export const PAYMENT_STATUS_DECLINED = 'declined';
export const PAYMENT_STATUS_AUTHORIZED = 'authorized';
export const PAYMENT_STATUS_CAPTURED = 'captured';
export const PAYMENT_STATUS_VOIDED = 'voided';
export const PAYMENT_STATUS_SETTLED = 'settled';
export const PAYMENT_STATUS_PARTIALLY_REFUNDED = 'partially_refunded';
export const PAYMENT_STATUS_RETURNED = 'returned';
export const PAYMENT_STATUS_REFUNDED = 'refunded';

export const TRANSACTION_STATUS_ERROR = 'error';
export const TRANSACTION_STATUS_DECLINED = 'declined';
export const TRANSACTION_STATUS_AUTHORIZE = 'authorized';
export const TRANSACTION_STATUS_CAPTURE = 'captured';
export const TRANSACTION_STATUS_VOIDED = 'voided';
export const TRANSACTION_STATUS_SETTLED = 'settled';
export const TRANSACTION_STATUS_REFUNDED = 'refunded';
export const TRANSACTION_STATUS_RETURNED = 'returned';
export const TRANSACTION_STATUS_PARTIALLY_REFUNDED = 'partially_refunded';
export const TRANSACTION_STATUS_VERIFICATION = 'verification';

export const TRANSACTION_SUCCESSFUL_STATUSES = [
  TRANSACTION_STATUS_AUTHORIZE,
  TRANSACTION_STATUS_CAPTURE,
  TRANSACTION_STATUS_VOIDED,
  TRANSACTION_STATUS_SETTLED,
  TRANSACTION_STATUS_REFUNDED
];

export const BATCH_STATUS_OPEN = 'BATCH_OPEN';

export const SUBSCRIPTION_STATUS_ACTIVE = 'Active';
export const SUBSCRIPTION_STATUS_CANCELLED = 'Cancelled';

export const MERCHANT_STATUSES = {
  DECLINED: 'DECLINED',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  APPROVED_MANUAL_REVIEW: 'APPROVED_MANUAL_REVIEW',
  APPROVED_PERIODIC_RISK_REVIEW: 'APPROVED_PERIODIC_RISK_REVIEW',
  APPROVED_ESCALATED_RISK_REVIEW: 'APPROVED_ESCALATED_RISK_REVIEW',
  APPROVED_SUBJECT_TO: 'APPROVED_SUBJECT_TO',
  APPROVED_FRAUD_REVIEW: 'APPROVED_FRAUD_REVIEW',
  PENDING_FURTHER_REVIEW: 'PENDING_FURTHER_REVIEW',
  PENDING_BANK_APPROVAL: 'PENDING_BANK_APPROVAL',
  DECLINED_COMPLIANCE: 'DECLINED_COMPLIANCE',
  DECLINED_RISK: 'DECLINED_RISK'
};

export const MERCHANT_ACTIVATION_STATUSES = {
  THIRDPARTY: 'thirdParty',
  WAITINGSUBMIT: 'waitingSubmit',
  SUBMITED: 'submited'
};

export const DECLINED_MERCHANT_STATUSES = [
  MERCHANT_STATUSES.DECLINED,
  MERCHANT_STATUSES.DECLINED_RISK,
  MERCHANT_STATUSES.DECLINED_COMPLIANCE
];

export const PENDING_MERCHANT_STATUSES = [
  MERCHANT_STATUSES.PENDING,
  MERCHANT_STATUSES.PENDING_BANK_APPROVAL,
  MERCHANT_STATUSES.PENDING_FURTHER_REVIEW
];

export const APPROVED_MERCHANT_STATUSES = [
  MERCHANT_STATUSES.APPROVED,
  MERCHANT_STATUSES.APPROVED_MANUAL_REVIEW,
  MERCHANT_STATUSES.APPROVED_FRAUD_REVIEW,
  MERCHANT_STATUSES.APPROVED_ESCALATED_RISK_REVIEW,
  MERCHANT_STATUSES.APPROVED_PERIODIC_RISK_REVIEW,
  MERCHANT_STATUSES.APPROVED_SUBJECT_TO
];

export const USER_STATUSES = {
  INACTIVE: 'Inactive'
};

export const SUBSCRIPTION_STATUSES = [
  SUBSCRIPTION_STATUS_ACTIVE,
  SUBSCRIPTION_STATUS_CANCELLED
];

export const INVOICE_STATUS_DRAFT = 'Draft';
export const INVOICE_STATUS_OPEN = 'Open';
export const INVOICE_STATUS_PASTDUE = 'PastDue';
export const INVOICE_STATUS_VOIDED = 'Voided';
export const INVOICE_STATUS_PAID = 'Paid';
export const INVOICE_STATUS_UNCOLLECTIBLE = 'Uncollectible';
